import React, { useEffect, useState } from "react";

// ANT DESIGN
import { ReloadOutlined, SearchOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Typography,
} from "antd";

//PROJECT IMPORTS
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomPagination from "../../components/CustomPagination";
import { handleFlgStatus } from "../../components/facilities/TreasuryFacility";
import MainLayout from "../../components/layouts/enhancement/MainLayout";
import TopContent from "../../components/layouts/enhancement/TopContent";
import { rightAction } from "../../redux/actions";
import cnt from "../../services/definedConstant";
import { BOM } from "../../services/definedMethod";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../customer/customer.config";

//global distructures
const { Text, Link, Title } = Typography;

const ManageCollateral = (props) => {
  const navigate = useNavigate();

  //DECLARED VARIABLES
  const { userData, rightBtn, rightAction } = props;

  const { session } = userData;
  const [collateralList, setCollateralList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [originalList, setOriginalList] = useState([]);
  const [tableCount, setTableCount] = useState("10");
  // const [perPage, setPerPage] = useState(10);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("status");
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [isSearch, setIsSearch] = React.useState(1);
  const dispatch = useDispatch();
  const [useForm] = Form.useForm();

  const filteredCollateralList =
    selectedStatus === "status"
      ? collateralList
      : collateralList.filter(
          (item) =>
            item?.status?.toLowerCase() === selectedStatus.toLowerCase(),
        );

  const columns = [
    {
      title: labelConfig.clientId,
      dataIndex: "clientId",
      sorter: (a, b) => a["clientId"].localeCompare(b["clientId"]),
    },
    {
      title: labelConfig.collateralCode,
      dataIndex: "collateralCode",
    },
    {
      title: labelConfig.collateralName,
      dataIndex: "collateralName",
      sorter: (a, b) => a.collateralName.localeCompare(b.collateralName),
    },
    {
      title: labelConfig.status,
      dataIndex: "status",
      render: (_, record) => {
        return <Text> {handleFlgStatus(record?.status, {}, true)}</Text>;
      },
    },
  ];

  //DECLARED METHODS

  useEffect(() => {
    BOM.HasPermission("READ_COLLATERAL") && getCollateralListAction();
    BOM.HasPermission("CREATE_COLLATERAL") && rightAction(cnt.RIGHT_ADD_BTN);
  }, [selectedStatus]);

  const getCollateralListAction = (offset = 0, limit = Number(tableCount)) => {
    setCurrentPage(1);
    const params = {
      limit: limit,
      offset: offset,
      orderBy: "id",
      sortOrder: "DESC",
      ...(selectedStatus !== "status" && { status: selectedStatus }),
    };

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    setIsSearch(false);
    BOM.FetchReqAction(body, apiConfig.GetCollaterals, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setTotalItems(res?.totalFilteredRecords);
        const objList = res.pageItems;
        let tempArray = [];

        objList.forEach((element) => {
          const statusValue = element?.status ? element?.status.value : "-";
          tempArray.push({
            key: element?.id,
            id: element?.id,
            clientId: element?.client?.id ? element?.client?.id : "-",
            collateralId: element?.id ? element?.id : "-",
            collateralCode: element?.collateralCode
              ? element?.collateralCode
              : "-",
            collateralName: element?.collateralName
              ? element?.collateralName
              : "-",
            status:
              statusValue?.toLowerCase() === "submitted and pending approval"
                ? "Pending"
                : statusValue,
          });
        });
        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        setCollateralList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  //DECLARED METHODS
  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [
      BOM.HasPermission("READ_COLLATERAL") && cnt.RIGHT_DETAIL_BTN,
      BOM.HasPermission("UPDATE_COLLATERAL") && cnt.RIGHT_EDIT_BTN,
    ].map((item) => {
      dispatch({
        type: item,
      });
    });
  };

  function selectTableCount(value) {
    setTableCount(value);
    onRefresh(0, value);
  }

  function handleStatusChange(value) {
    setSelectedStatus(value);
    setCurrentPage(1);
  }

  function handleOnView() {
    // console.log(selectedRow);
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/detail-collateral", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/new-collateral", { state: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }

  function handleOnEdit() {
    // console.log(selectedRow);
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/edit-collateral", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  const onSearch = (formValue) => {
    setIsLoading(true);

    const params = {
      exactMatch: false,
      query: formValue.searchKey,
      resource: "clients,clientIdentifiers",
    };

    let body = {
      session,
      params,
    };
    setIsSearch(true);
    BOM.FetchReqAction(body, apiConfig.Search, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        let tempArray = [];
        setIsLoading(false);

        objList.forEach((element) => {
          const statusValue = element?.entityStatus
            ? element?.entityStatus.value
            : "-";
          tempArray.push({
            key: element?.id,
            id: element?.id,
            clientId: element?.client?.id ? element?.client?.id : "-",
            collateralId: element?.id ? element?.id : "-",
            collateralCode: element?.collateralCode
              ? element?.collateralCode
              : "-",
            collateralName: element?.collateralName
              ? element?.collateralName
              : "-",
            status:
              statusValue?.toLowerCase() === "submitted and pending approval"
                ? "Pending"
                : statusValue,
          });
        });

        // //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        setCollateralList(tempArray);

        // //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);
        // //STOP LOAD
      }
    });
  };

  const onRefresh = (offset = 0, limit = Number(tableCount)) => {
    useForm.resetFields();
    getCollateralListAction(offset, limit);
    setCurrentPage(1);
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onAdd={handleOnCreate}
      onEdit={handleOnEdit}
      pageItems={staticConfig.manageCollateralBreadcrumbItems}
    >
      <TopContent
        pageTitle={labelConfig.manageCollateral}
        createPageTitle={labelConfig.collateralListing}
      />

      {/* RENDER TABLE LIST */}
      <Card
        title={
          <>
            Collateral List{" "}
            <Button
              type="primary"
              shape="round"
              size="small"
              className="of-primaryBtnColor"
              onClick={() => onRefresh()}
              icon={<ReloadOutlined />}
              loading={isLoading}
            >
              {labelConfig.refresh}
            </Button>
          </>
        }
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
          marginTop: 20,
        }}
      >
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text>Entries</Text>
            </div>

            <Row style={{ marginLeft: 10 }}>
              <Col span={24} style={{ padding: "0px 8px" }}>
                <Form form={useForm} onFinish={onSearch}>
                  <Space.Compact
                    style={{
                      width: "100%",
                      // border: "1px solid #d9d9d9",
                    }}
                  >
                    <Form.Item
                      name="searchKey"
                      rules={[
                        {
                          required: true,
                          message: BOM.CheckReqFld("This field "),
                        },
                      ]}
                    >
                      <Input
                        placeholder="Search by Collateral Name / ID"
                        style={{ width: 400 }}
                        allowClear
                      />
                    </Form.Item>
                    <Button
                      type="primary"
                      className="of-primaryBtnColor"
                      htmlType="submit"
                      style={{ borderRadius: "0px 5px 5px 0px" }}
                    >
                      <SearchOutlined />
                    </Button>
                    <div style={{ marginLeft: "20px" }}>
                      <div style={{ marginBottom: "auto", marginLeft: 10 }}>
                        <Select
                          value={selectedStatus}
                          options={staticConfig.collateralStatusOptions}
                          onChange={handleStatusChange}
                          placeholder={"Select Status"}
                          dropdownStyle={{ width: "250px" }}
                          className="interbank-table-select"
                        />
                      </div>
                      {/* <StatusSelect
                        statusOptions={staticConfig.customerStatusOptions}
                        originalList={originalList}
                        onFilteredListChange={(data) => console.log(data)}
                        statusField="status"
                        defaultStatus={isSearch ? "status" : "active"}
                      /> */}
                    </div>
                  </Space.Compact>
                </Form>
              </Col>
            </Row>
            {/* <DownloadTableButtons
              downloadData={customerList}
              columns={columns}
              fileName="Customer List"
              onExportClick={getCsvListData}
            /> */}
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={filteredCollateralList}
            bordered
            //
            pagination={false}
            scroll={{ x: 800 }}
          />
          {!isSearch && (
            <CustomPagination
              totalItems={totalItems}
              pageSize={Number(tableCount)}
              onPageChange={(page, offset) => onRefresh(offset)}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          )}
        </Spin>
      </Card>
    </MainLayout>
  );
};
const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };

export default connect(mapStateToProps, mapDispatchToProps)(ManageCollateral);
